import Typography, { TypographyProps } from '@components/v2/ui/Typography/Typography';

interface FeedDateHeaderProps {
  label: string;
  component?: TypographyProps['component'];
  testId?: string;
}

const FeedDateHeader = ({ label, component, testId }: FeedDateHeaderProps) => (
  <Typography variant="micro1" color="text.secondary" component={component} testId={testId}>
    {label}
  </Typography>
);

FeedDateHeader.displayName = 'FeedDateHeader';
export type { FeedDateHeaderProps };
export default FeedDateHeader;
